import React, { useState } from 'react';
import { FlexBox, FormItem, Typography, ButtonNew } from '@helloworld1812/ws-components';
import { User } from '@helloworld1812/hr-api';
import { useTranslation } from 'react-i18next';
import { CountryData } from 'react-intl-tel-input';

import IntlTelInput from '@/components/intl-tel-input';
import { useHrMutation } from '@/api';

import downloadImage from '../../assets/download-app@2x.png';
import { cleanupPhoneNumber } from '../../utils';

interface DownloadAppStepProps {
  user: User;
}

export function DownloadAppStep({ user }: DownloadAppStepProps) {
  const { t } = useTranslation('hr-account-routes');
  const initialPhoneState = () => {
    let { region_number: regionNumber = '', phone: phoneNumber = '' } = user;
    phoneNumber = phoneNumber || '';
    regionNumber = regionNumber || '';
    phoneNumber = cleanupPhoneNumber(phoneNumber, regionNumber);
    return { phoneNumber, regionNumber };
  };

  const {
    mutateAsync: sendAppLink,
    isLoading: isSendingAppLink,
    isSuccess,
  } = useHrMutation({
    method: 'post',
    url: '/v1/users/send_app_link',
  });

  const [phoneState, setPhoneState] = useState(initialPhoneState());
  const [isValid, setIsValid] = useState(true);
  const { phoneNumber, regionNumber } = phoneState;

  const handleClickSend = () => {
    if (!phoneNumber) {
      setIsValid(false);
      return;
    }

    sendAppLink({
      data: {
        phone: phoneNumber,
        region_number: regionNumber,
      },
    });
  };

  const onPhoneNumberChange = (status: boolean, value: string, countryData: CountryData) => {
    const newRegionNumber = countryData.dialCode || '';
    const newPhoneNumber = cleanupPhoneNumber(value, newRegionNumber);

    setPhoneState({ phoneNumber: newPhoneNumber, regionNumber: newRegionNumber });
    setIsValid(status);
  };

  return (
    <FlexBox column w="100%">
      <Typography variant="h2" fontSize={22} fontWeight="bold" mb={32}>
        {t("Download Workstream's app to hire fast today!")}
      </Typography>
      <FlexBox height={360} style={{ position: 'relative' }} align="center" justify="flex-end" pr={40}>
        <img
          style={{ width: '518px', objectFit: 'contain', position: 'absolute', top: 0, left: 0 }}
          alt={t("Download Workstream's app with paper plane")}
          src={downloadImage}
        />
        {isSuccess ? (
          <Typography variant="h3" fontSize={16} fontWeight="bold">
            {t('Successfully sent download link!')}
          </Typography>
        ) : (
          <FlexBox column gap={16}>
            <FormItem
              label={t('Enter cell phone number')}
              error={!isValid && { message: t('Please enter a correct phone number') }}
            >
              <IntlTelInput
                preferredCountries={['us', 'sg', 'ca']}
                style={{ width: 250 }}
                defaultValue={phoneNumber && regionNumber && `+${regionNumber}${phoneNumber}`}
                onPhoneNumberChange={onPhoneNumberChange}
              />
            </FormItem>
            <ButtonNew size="compact" type="primary" loading={isSendingAppLink} onClick={handleClickSend}>
              {t('Send link to download')}
            </ButtonNew>
          </FlexBox>
        )}
      </FlexBox>
    </FlexBox>
  );
}
